<template>
  <div :class="theme">
    <div class="articleMain">
      <div class="articleMain--col articleMain--col1">
        <div class="articleMain--title">
          <h2 class="titleFeatured">{{ titleResume }}</h2>
        </div>
        <div class="articleMain--subtitle">
          <h2 class="subtitle">
            <strong>{{ title }}</strong>
          </h2>
        </div>
        <div class="articleMain--text" v-html="text"></div>
        <div class="articleMain--links">
          <LinksGroup
          :linkPT='linkPT'
          :linkES='linkES'
          :linkIN='linkIN'/>
        </div>
      </div>
      <div class="articleMain--col articleMain--col2">
        <div class="articleMain--image">
          <ImgClean
          :imgFull='imgFull'
          :imgLarge='imgLarge'
          :imgMedium='imgMedium'
          :imgSmall='imgSmall'/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgClean from '@/components/_ImgClean'
import LinksGroup from '@/components/_LinksGroup'

export default {
  name: 'ArticleMain',
  components: {
    ImgClean,
    LinksGroup
  },
  props: {
    theme: {
      type: String,
      default: 'theme1'
    },
    titleResume: {
      type: String,
      default: 'ArticleMain TitleResume'
    },
    title: {
      type: String,
      default: 'ArticleMain title'
    },
    text: {
      type: String,
      default: 'ArticleMain text'
    },
    linkPT: {
      default: '#linkpt'
    },
    linkES: {
      default: '#linkES'
    },
    linkIN: {
      default: '#linkIN'
    },
    alt: {
      type: String,
      default: 'Observatório Internacional de Capacidades Humanas, Desenvolvimento e Políticas Públicas'
    },
    imgFull: {
      type: String,
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    },
    imgLarge: {
      type: String,
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    },
    imgMedium: {
      type: String,
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    },
    imgSmall: {
      type: String,
      default: 'http://capacidadeshumanas.org/oichsitev3/wp-content/uploads/2018/10/default.png'
    }
  }
}
</script>

<style>

</style>
